module.exports = " <div class=vc-ripple-ink :style=\"{'color': color}\"></div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ripple.vue
 ** module id = 477
 ** module chunks = 1
 **/